export const SET_IDENTITY_FIELDS = 'SET_IDENTITY_FIELDS';
export const SET_IDENTITY_ERRORS = 'SET_IDENTITY_ERRORS';
export const SET_ADDRESS_FIELDS = 'SET_ADDRESS_FIELDS';
export const SET_ADDRESS_ERRORS = 'SET_ADDRESS_ERRORS';
export const SET_CONTACT_INFORMATION_FIELDS = 'SET_CONTACT_INFORMATION_FIELDS';
export const SET_CONTACT_INFORMATION_ERRORS = 'SET_CONTACT_INFORMATION_ERRORS';
export const SET_IDENTITY_VERIFICATION_FIELDS = 'SET_IDENTITY_VERIFICATION_FIELDS';
export const SET_IDENTITY_VERIFICATION_ERRORS = 'SET_IDENTITY_VERIFICATION_ERRORS';
export const SET_EMPLOYMENT_AND_INCOME_FIELDS = 'SET_EMPLOYMENT_AND_INCOME_FIELDS';
export const SET_EMPLOYMENT_AND_INCOME_ERRORS = 'SET_EMPLOYMENT_AND_INCOME_ERRORS';
export const SET_ADDITIONAL_CARDHOLDER_FIELDS = 'SET_ADDITIONAL_CARDHOLDER_FIELDS';
export const SET_ADDITIONAL_CARDHOLDER_ERRORS = 'SET_ADDITIONAL_CARDHOLDER_ERRORS';
export const SET_CONSUMER_APPLICATION_DEVICE_ID = 'SET_CONSUMER_APPLICATION_DEVICE_ID';
export const SET_CONSUMER_APPLICATION_FI_ID = 'SET_CONSUMER_APPLICATION_FI_ID';
export const SET_CONSUMER_APPLICATION_RESERVATION_CODE = 'SET_CONSUMER_APPLICATION_RESERVATION_CODE';

export const SET_CONSUMER_RESPONSE = 'SET_CONSUMER_RESPONSE';
export const SET_CONSUMER_RESPONSE_ERRORS = 'SET_CONSUMER_RESPONSE_ERRORS';

export const SET_CONSUMER_APPLICATION_VALID = 'SET_CONSUMER_APPLICATION_VALID';
export const SET_CONSUMER_APPLICATION_STATUS = 'SET_CONSUMER_APPLICATION_STATUS';

export const SET_DOCUMENT_REQUEST_RESERVATION_CODE = 'SET_DOCUMENT_REQUEST_RESERVATION_CODE';
export const SET_DOCUMENT_REQUEST_FI_ID = 'SET_DOCUMENT_REQUEST_FI_ID';

export const SET_ACCOUNT_CONVERSION_STATUS = 'SET_ACCOUNT_CONVERSION_STATUS';